import React from "react";

const MAP = {
  pendiente:   { label: "Pendiente",   color: "#FCA311" },
  en_progreso: { label: "En progreso", color: "#0055FF" },
  completada:  { label: "Completada",  color: "#2A9D8F" },
  activo:      { label: "Activo",      color: "#2A9D8F" },
  prospecto:   { label: "Prospecto",   color: "#FCA311" },
  inactivo:    { label: "Inactivo",    color: "#8A8A8A" },
  alta:        { label: "Alta",        color: "#E63946" },
  media:       { label: "Media",       color: "#FCA311" },
  baja:        { label: "Baja",        color: "#2A9D8F" },
};

export default function StatusPill({ value, testid }) {
  const info = MAP[value] || { label: value, color: "#8A8A8A" };
  return (
    <span className="status-pill" data-testid={testid}>
      <span className="status-dot" style={{ background: info.color }} />
      {info.label}
    </span>
  );
}
